import { z } from 'zod';
import { paginationFiltersSchema, sortFiltersSchema } from 'utils/schemas';

export const shopUsersFiltersSchema = z
  .object({
    employeeIds: z.array(z.string()).catch([]),
    name: z.string().catch(''),
    email: z.string().catch(''),
    phoneNumber: z.string().catch(''),
    search: z.string().catch(''),
  })
  .merge(sortFiltersSchema)
  .merge(paginationFiltersSchema);
